module.exports = __webpack_public_path__ + "img/course_cate_03.53db4723.png";